import { render, staticRenderFns } from "./SummaryGraph.vue?vue&type=template&id=3724caca&scoped=true"
import script from "./SummaryGraph.vue?vue&type=script&lang=js"
export * from "./SummaryGraph.vue?vue&type=script&lang=js"
import style0 from "./SummaryGraph.vue?vue&type=style&index=0&id=3724caca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3724caca",
  null
  
)

export default component.exports